module.exports = (__webpack_require__(66))("./node_modules/@restart/hooks/esm/useGlobalListener.js");